import React from 'react';
import { ActivityIndicator, Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';

export default function SupportChatIntro({ onSuggestionPress, sendingQuestion }) {
  const { colors } = useTheme();
  const { t } = useTranslation();
  return <View style={styles.container}>
    <View style={[styles.icon, { backgroundColor: colors.solid_color_tertiary }]}>
      <Icon name="comments" size={28} color={colors.text_color_primary} />
    </View>
    <Text size="xxxl" weight="bold" accessibilityRole="header" style={styles.title}>{t('settings.help.askArya')}</Text>
    <Text size="m" color="secondary" style={styles.description}>{t('settings.help.aryaWelcome')}</Text>
    <View style={styles.suggestions}>
      {['gettingStarted', 'credits', 'work', 'account'].map(key => {
        const question = t(`settings.help.questions.${key}`);
        return <Pressable key={key} accessibilityRole="button" onPress={() => onSuggestionPress(question)}
          disabled={!!sendingQuestion} accessibilityState={{ disabled: !!sendingQuestion, busy: sendingQuestion === question }}
          style={({ hovered, pressed }) => [styles.suggestion, { borderColor: colors.border_color_secondary,
            backgroundColor: hovered || pressed ? colors.solid_color_tertiary : 'transparent' }]}>
          <Text size="n" style={styles.question}>{question}</Text>
          {sendingQuestion === question ? <ActivityIndicator size="small" color={colors.text_color_secondary} />
            : <Icon name="arrow-up-right" size={13} color={colors.text_color_secondary} />}
        </Pressable>;
      })}
    </View>
  </View>;
}

const styles = StyleSheet.create({
  container: { width: '100%', maxWidth: 620, alignItems: 'center' },
  icon: { width: 64, height: 64, borderRadius: 20, alignItems: 'center', justifyContent: 'center', marginBottom: 24 },
  title: { textAlign: 'center', marginBottom: 12 },
  description: { textAlign: 'center', lineHeight: 23, maxWidth: 480, marginBottom: 32 },
  suggestions: { width: '100%', gap: 10 },
  suggestion: { flexDirection: 'row', alignItems: 'center', gap: 16, borderWidth: 1, borderRadius: 14, paddingHorizontal: 18, paddingVertical: 16, minHeight: 54 },
  question: { flex: 1, lineHeight: 21 },
});
